import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useParams, useLocation, useHistory} from 'react-router-dom';
import queryString from 'query-string';
import CircularProgress from '@mui/material/CircularProgress';

import PDFViewer from './PDFViewer';
import WordWorkApp from '../word-work/components/WordWorkApp';
import WordSortApp from '../word-sort/components/WordSortApp';
import WordDivisionApp from '../word-division/components/WordDivisionApp';
import Writing from './Writing';
import {selectExercise, fetchExercise, selectIsLoading} from '../redux/slices/lesson';
import {updateExercise} from '../redux/slices/builder';
import {APP_WORD_WORK, APP_WORD_SORT, APP_WORD_DIVISION, APP_READING, APP_WRITING, APP_ASSESSMENT} from '../constants';

import styles from '../css/ExerciseViewer.module.css';
import baseStyles from '../css/Base.module.css';

export default function ExerciseViewer() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {exerciseID} = useParams();
  const exercise = useSelector(selectExercise);
  const isLoading = useSelector(selectIsLoading);

  const queryStrings = queryString.parse(location.search);

  useEffect(() => {
    dispatch(fetchExercise(exerciseID));
  }, [dispatch, exerciseID]);

  function handleSave(config) {
    dispatch(updateExercise(exerciseID, {config}));

    if (queryStrings.return) history.push(queryStrings.return);
  }

  function renderExercise() {
    const {type} = exercise;
    const props = {
      mode: 'EXERCISE',
      exercise,
    };

    if ([APP_READING, APP_ASSESSMENT].includes(type)) return <PDFViewer {...props} />;
    else if (type === APP_WORD_WORK) {
      const isEditable = queryStrings.edit;
      return <WordWorkApp {...props} handleSave={handleSave} isEditable={isEditable} />;
    } else if (type === APP_WORD_SORT) {
      const isEditable = queryStrings.edit;
      return <WordSortApp {...props} handleSave={handleSave} isEditable={isEditable} />;
    } else if (type === APP_WORD_DIVISION) {
      return <WordDivisionApp {...props} />;
    } else if (type === APP_WRITING) return <Writing {...props} />;
    else return <div>APP TYPE {type} NOT SUPPORTED</div>;
  }

  return (
    <>
      {isLoading && (
        <div className={baseStyles['progress-container']}>
          <CircularProgress />
        </div>
      )}

      <div className={styles.container}>{!isLoading && exercise && renderExercise()}</div>
    </>
  );
}
